import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { isArray } from 'lodash';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { SimpleTable } from '~/components';

import { t } from '~/helpers';
import api from '~/services/api';

import { FormWrapper } from './styles';

import * as S from './styles';

export default function MyForm({ data, reference, close }) {

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        movi_totalizador_veiculo_novo: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(0),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {};

      await api.put('alterartotalizadorabastecimento', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>
      <S.Wrapper>
        <FormWrapper ref={reference} initialData={data} onSubmit={handleSubmit}>
          
          <SimpleTable
            style={{ width: '100px' }}
            url="operacaobloqueioveiculoprefaturahistoricoitem/produto"
            cells={[
              {
                id: 'prde_codigo',
                label: 'Cód Produto',          
              },
              {
                id: 'prde_nome',
                label: 'Nome do Produto',
              },
              {
                id: 'prod_status',
                label: 'Status',
              },
            ]}
            unique={['prde_codigo']}
            form={MyForm}
            onCreate={false}
            onUpdate={false}
            onDelete={false}
            title={'Histórico de Produto do Veículo Pré-Faturas'}
            restProps={''}
            query={{
              wherefield: ['veic_placa'],
              valuewherefield: [data.veic_placa],
              typewherefield: ['EQUALS'],
            }}
          />
        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
